// courtsRepository.js
// API repository for courts-related backend calls
import authService from './authService.js';
import { buildApiUrl } from './apiUtils.js';

export const CourtsRepository = {
    async fetchCourts() {
        const response = await fetch(buildApiUrl('/courts'), { 
            method: 'GET', 
            headers: { 'Accept': 'application/json' } 
        });
        if (!response.ok) throw new Error('Błąd ładowania kortów: ' + response.statusText);
        const data = await response.json();
        return Array.isArray(data) ? data : (data.courts || []);
    },

    async updateCourt(courtId, courtData) {
        const response = await authService.authenticatedRequest(buildApiUrl(`/courts/${courtId}`), {
            method: 'PATCH',
            body: JSON.stringify(courtData)
        });
        
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to update court: ${response.status} ${response.statusText} - ${errorText}`);
        }
        
        const responseText = await response.text();
        if (!responseText) {
            return { success: true }; // Empty response is OK
        }
        
        try {
            return JSON.parse(responseText);
        } catch (e) {
            // If response is not JSON, return success with the text
            return { success: true, message: responseText };
        }
    }
};

export default CourtsRepository;
